/**
 * @module
 */
import {COMPILE} from '@acng/frontend-stargazer';
import {guard, INTERFACE, IS, OBJECT, STRING} from '@acng/frontend-rubicon';
import {post} from 'acng/core/service/backend.js';
import {popup} from '@acng/frontend-discovery';
import {SubmitEventController} from 'nova';

import {t} from '../../locale/config/translate.js';
import {getLocalOverlay} from '../../core/service/overlay.js';
import {user} from '../user.js';

class UserRename extends SubmitEventController {
  /**
   * @param {HTMLFormElement} form
   * @param {FormData} data
   *
   * @returns {Promise<void>}
   */
  async submit(form, data) {
    await post('user/rename', data, form);
    user.nickname = data.get('nickname');
    await popup(form).info(await t('userPool.nicknameChanged'));
    getLocalOverlay(form)?.close();
  }

  /**
   * @param {Element} form
   *
   * @returns {void}
   */
  [COMPILE](form) {
    ASSERT: {
      guard(form, IS(HTMLFormElement));
      guard(form.elements, INTERFACE({nickname: IS(HTMLInputElement)}));
    }

    const {nickname} = form.elements;
    nickname.type = 'text';
    nickname.required = true;
  }
}

export {UserRename};
